(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDeleteController',TypeAssociationDeleteController);

    TypeAssociationDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeAssociation'];

    function TypeAssociationDeleteController($uibModalInstance, entity, TypeAssociation) {
        var vm = this;

        vm.typeAssociation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TypeAssociation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
